import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { billTypeMap } from '../../util/billingConsts'
import { BoldBodyText } from '../styles/Text'

const STATUS_LABEL = {
  DRAFTING: 'Draft',
  AWAITING_APPROVAL: 'Review',
  READY_TO_SEND: 'Send'
}

const Status = styled.span`
  font-weight: 700;
`

function taskStatus({ type, letter, bill }) {
  return type === 'LETTER' ? letter?.status : bill?.status
}

function taskRest({ type, letter, bill }) {
  if (type === 'LETTER') return letter?.name || ''
  const typeLabel = billTypeMap[bill?.billType] || bill?.billType || ''
  return `${bill?.secondaryId || ''} - ${typeLabel}`
}

export function formatTaskTitle(task) {
  const prefix = STATUS_LABEL[taskStatus(task)] || ''
  return `${prefix}: ${taskRest(task)}`
}

function TaskName({ type, letter, bill }) {
  const task = { type, letter, bill }

  return (
    <BoldBodyText as="span">
      <Status>{STATUS_LABEL[taskStatus(task)] || ''}:</Status> {taskRest(task)}
    </BoldBodyText>
  )
}

TaskName.propTypes = {
  type: PropTypes.oneOf(['LETTER', 'BILL']).isRequired,
  letter: PropTypes.shape({
    name: PropTypes.string,
    status: PropTypes.string
  }),
  bill: PropTypes.shape({
    secondaryId: PropTypes.string,
    billType: PropTypes.string,
    status: PropTypes.string
  })
}

export default TaskName
